import styled from 'styled-components';

export const SurveyCustomModal = styled.div`
  width: 608px;
  border-radius: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const PageTitle = styled.span`
  color: rgba(9, 21, 38, 0.85);
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  display: block;
`;

export const PageNumber = styled.span`
  color: rgba(9, 21, 38, 0.85);
  text-align: center;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  display: block;
`;

export const Question = styled.div`
  color: rgba(9, 21, 38, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 137.5% */
`;
export const Answer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
`;

export const PolicyLink = styled.a`
  color: #985eff;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  outline: none;
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: #985eff;
  }
`;

export const Policy = styled.span`
  color: rgba(9, 21, 38, 0.85);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
`;
export const Required = styled.span`
  color: rgba(9, 21, 38, 0.85);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;
